export default __webpack_public_path__ + "images/97a254d74d3095944e23de0a34399584.svg";